import React, { useEffect, useState } from "react";
import PathDisplay from "../common/PathDisplay";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import PathInfo from "../../model/PathInfo";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";
import APIEndPoints from "../../utils/APIEndPoints";
import Collection from "../../model/Collection";

function Collections() {
  // read the ID from the url
  const { sid } = useParams();
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (sid) {
        const info = await apiClient?.get<Collection>({
          url: APIEndPoints.COLLECTIONS.ONE(parseInt(sid)),
        });

        setPathInfo(
          new PathInfo(
            info.id!,
            info.name,
            ChemiNovaEntityType.COLLECTION,
            undefined,
          ),
        );
      } else {
        setPathInfo(undefined);
      }
    };
    getPathInfo();
  }, [location, apiClient, sid]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default Collections;
